import React from 'react';
import SubcategoryListItemWithSublists from './SubcategoryListItemWithSublists';
import SubcategoryListItem from './SubcategoryListItem';

function AreaCategoriesList(props) {

    const subcategories = props.subcategories;

    if (typeof subcategories === 'undefined') {
        return null;
    } else {
        return (
            <ul className="area-categories__list">
                {subcategories.map(subcategory => constructSubcategoryListItem(subcategory))}
            </ul>
        );
    }

    function constructSubcategoryListItem(subcategory) {
        if (subcategory.subareas.length > 0) {
            return contructDropdownItem(subcategory);
        } else {
            return constructSingleItem(subcategory);
        }
    }

    function contructDropdownItem(subcategory) {
        return (
            <SubcategoryListItemWithSublists
                key={subcategory.id}
                subcategory={subcategory}
                constructSingleItem={constructSingleItem}
                isAreaActive={props.isAreaActive}
                checkIfShouldAddScroll={props.checkIfShouldAddScroll}
                contentContainerRef={props.contentContainerRef}
            />
        );
    }

    function constructSingleItem(subcategory) {
        return (
            <SubcategoryListItem
                key={subcategory.id}
                subcategory={subcategory}
            />
        )
    }
}

export default AreaCategoriesList;